@if (isOldBrowser) {
  <div class="old-b-wrap">
    <div class="old-b-wrap__style">
      <a class="js-close-old-b-wrap i-close" translate="old-browser.label.close" (click)="close()"></a>
      <div class="old-b-wrap__title" translate="old-browser.header"></div>
      <div class="old-b-wrap__sub-title" translate="old-browser.message.update-it"></div>
      <div class="old-b-wrap__list-img">
        <a target="_blank" [href]="'http://outdatedbrowser.com/' + languageA2">
          <img alt="" src="assets/img/browsers.png">
        </a>
      </div>
    </div>
  </div>
}
